import { Spacer, Toggle, Icon, Dropdown } from "@dspworkplace/ui";
import DeliveryMethodSelector from "./DeliveryMethodSelector";
import MessagePreview from "./MessagePreview";
import { useFormContext } from "react-hook-form";
import { useEffect } from "react";
import {
    ReminderTitle,
    ReminderDescription,
    FieldWrapper,
    DropdownWrapper,
    CustomLabel,
} from "./styled";
import { MINUTES_OPTIONS, REPEAT_COUNT_OPTIONS } from "./constants";

const ReminderCard = ({ cardData, handleVisible }) => {

    const { title, description, type, sendAfterText, sendAfterOptions } = cardData;

    const { register, watch, setValue, getValues } = useFormContext();

    const selectedMethod = watch(`${type}.delivery_method`);
    const enabled = watch(`${type}.enabled`);
    const previewMessage = watch(`${type}.message`);

    useEffect(() => {
        register({ name: `${type}.enabled` });
    }, [register, type]);

    const values = getValues({ nest: true });

    return (
        <>
            <div>
                <Toggle
                    name={`${type}.enabled`}
                    singleText={
                        <div>
                            <ReminderTitle>{title}</ReminderTitle>
                            <ReminderDescription>{description}</ReminderDescription>
                        </div>
                    }
                    on={!!enabled}
                    value={enabled}
                    onChange={(e) => setValue(`${type}.enabled`, e.target.checked)}
                />
            </div>

            <Spacer bottom={4} />

            <FieldWrapper>
                <CustomLabel>
                    <div>Send after</div>
                    <Icon.Check size="16px" color="#14b8a6" />
                </CustomLabel>
                <DropdownWrapper>
                    <Dropdown
                        name={`${type}.send_after`}
                        options={sendAfterOptions}
                        size='extraSmall'
                        visibleOptionsQty={6}
                        ref={register}
                        disabled={!enabled}
                        valid={enabled ? "true" : null}
                        defaultValue={values?.[type]?.send_after ?? null}
                    />
                    <span>{sendAfterText}</span>
                </DropdownWrapper>
            </FieldWrapper>

            <Spacer bottom={3} />

            <FieldWrapper>
                <CustomLabel>
                    <div>Delivery Method</div>
                    <Icon.Check size="16px" color="#14b8a6" />
                </CustomLabel>
                <input type="hidden" name={`${type}.delivery_method`} ref={register()} />
                <DeliveryMethodSelector
                    value={selectedMethod}
                    onChange={(value) => setValue(`${type}.delivery_method`, value)}
                    disabledField={!enabled}
                />
            </FieldWrapper>

            <Spacer bottom={3} />

            <FieldWrapper>
                <CustomLabel>
                    <div>Resend if no action</div>
                    <Icon.Check size="16px" color="#14b8a6" />
                </CustomLabel>
                <DropdownWrapper>
                    <span>Every</span>
                    <Dropdown
                        name={`${type}.repeat_every`}
                        options={MINUTES_OPTIONS}
                        size='extraSmall'
                        visibleOptionsQty={6}
                        ref={register}
                        disabled={!enabled}
                        valid={enabled ? "true" : null}
                        defaultValue={values?.[type]?.repeat_every ?? null}
                    />
                    <span>min, up to</span>
                    <Dropdown
                        name={`${type}.repeat_count`}
                        options={REPEAT_COUNT_OPTIONS}
                        size='extraSmall'
                        visibleOptionsQty={6}
                        ref={register}
                        disabled={!enabled}
                        valid={enabled ? "true" : null}
                        defaultValue={values?.[type]?.repeat_count ?? null}
                    />
                    <span>times</span>
                </DropdownWrapper>
            </FieldWrapper>

            <Spacer bottom={3} />

            <MessagePreview
                handleVisible={handleVisible}
                cardData={cardData}
            >
                {previewMessage}
            </MessagePreview>
        </>
    );
};

export default ReminderCard;
